import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';

import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#6c757d',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const PlateAnalysisTable = ({
  heading, rows, pageData, style, 
}) => {
  return(
    <Box style={style}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead>
            <TableRow>
              {heading.map((item, index) => (
                <StyledTableCell align="center" key={index}>{item}</StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <StyledTableRow key={index} style={{ cursor: 'pointer' }}>
                <StyledTableCell align="center" key={`SI-${index}`}>
                  {((pageData.current.pageNumber - 1) *10) + (index + 1)}
                </StyledTableCell>
                <StyledTableCell align="center" key={index}>
                  {row.plate_name}
                </StyledTableCell>
                {Object.keys(row).map((key, i) => ((
                  ( key !== 'id' && key !== 'plate_name' ) && 
                    <StyledTableCell align="center" key={i}>
                      {row[key] ? <DoneIcon color='success' /> : <ClearIcon color='error' />}
                    </StyledTableCell>
                  )))}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

PlateAnalysisTable.propTypes = {
  heading: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  pageData: PropTypes.object.isRequired,
  style: PropTypes.object,
};

export default PlateAnalysisTable;